import { render, staticRenderFns } from "./Raum.vue?vue&type=template&id=094b6a3c&scoped=true&"
import script from "./Raum.vue?vue&type=script&lang=js&"
export * from "./Raum.vue?vue&type=script&lang=js&"
import style0 from "./Raum.vue?vue&type=style&index=0&id=094b6a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094b6a3c",
  null
  
)

export default component.exports